<template>
  <div style="padding: 5px 0;">
    <Table
      :columns="columns"
      :data="marginDetailList"
      size="small"
    ></Table>
    <span v-if="cutList.length>0">
      <Button
        size="small"
        type="primary"
        style="margin-top:5px;margin-right:5px;"
        @click="showMore"
        v-if="!isShowStatus"
      >展开更多</Button>
      <Button
        size="small"
        type="primary"
        style="margin-top:5px;margin-right:5px;"
        @click="retract"
        v-if="isShowStatus"
      >收起</Button>
    </span>
    <Button
      v-if="marginDetailList.length>0"
      size="small"
      type="primary"
      style="margin-top:5px;"
      @click="receiveConfirm"
    >领取确认</Button>
    <Modal
      v-model="receiveConfirmVisible"
      title="保证金领取"
      width="1200"
      :mask-closable="false"
    >
      <!-- <div style="margin: 0 10px 10px;">
        <span>已确认保证金</span>
        <Table size="small" :columns="orderColumns" :data="orderList"></Table>
      </div> -->
      <div style="margin: 0 10px 10px;">
        <Button
          type="primary"
          size="small"
          @click="autoMatch"
        >自动匹配</Button>
        <span>（付款单位公司名字与报名供应商名字不一致时不会自动匹配）</span>
      </div>
      <div class="left-wrapper">
        <span style="margin-top:5px;">未匹配单位：</span>
        <div style="min-height:20px;border:1px solid #ddd;position:relative;">
          <draggable
            v-model="drapMarginList"
            :options="{group:'company', filter:'.item-drag'}"
            style="min-height:35px;"
            @add="addMarginItemBack"
          >
            <div
              v-for="(margin, index) in drapMarginList"
              :key="margin.id"
              class="margin-company left-margin"
              :class="{'item-drag':margin.isReceived}"
            >
              <Tooltip
                content="汇款单位名称与报名供应商名称不一致"
                v-if="margin.isDifferent"
                style="padding-right:3px;color:#ff9900"
                placement="right"
              >
                <Icon
                  type="ios-information-outline"
                  style="font-size:14px;"
                ></Icon>
              </Tooltip>
              <div style="width:230px;display:inline-block;">{{margin.ghfAccountName}}</div>
              <span class="amount">收取金额：{{margin.amount}}</span>
              <span
                class="confirm"
                style="color:#2d8cf0"
                v-if="margin.isReceived"
              >已确认</span>
              <span
                class="confirm"
                style="color:#ff9900"
                v-else
              >未确认</span>
              <Tooltip
                class="split"
                placement="left"
                content="金额拆分成多个包组收取"
              >
                <span
                  style="color:#2d8cf0"
                  @click="splitAmount(margin, index)"
                >拆分</span>
              </Tooltip>
            </div>
          </draggable>
          <div
            v-if="drapMarginList.length===0"
            style="width:100%;text-align:center;position:absolute;top:8px;"
          >拖拽到此</div>
        </div>
      </div>
      <div class="right-wrapper">
        <div
          v-for="(group, index) in groupList"
          style="margin-top:5px;"
        >
          <span>包组{{group.groupNo}}：{{group.groupName}}</span>
          <span>（应收保证金：{{group.marginAmount}}）</span>
          <div style="border:1px solid #ddd;position:relative;">
            <draggable
              v-model="group.marginCompanyList"
              :options="{group:'company', filter:'.item-drag'}"
              style="min-height:35px;"
              @add="addMarginItem"
            >
              <div
                v-for="(margin, marginIndex) in group.marginCompanyList"
                :key="margin.id"
                class="margin-company"
                :class="{'item-drag':margin.isReceived||margin.splitMarginId, ['group'+index]: true}"
              >
                <div style="width:230px;display:inline-block;">{{margin.ghfAccountName}}</div>
                <span class="get-amount">收取金额：{{margin.amount}}</span>
                <span
                  class="confirm"
                  style="color:#2d8cf0"
                  v-if="margin.isReceived"
                >已确认</span>
                <span
                  class="confirm"
                  style="color:#ff9900"
                  v-else
                >未确认</span>
                <span class="amount">确认金额：{{margin.confirmAmount}}</span>
                <Tooltip
                  style="position:absolute;right:40px;color:#19be6b"
                  placement="left"
                >
                  <div slot="content">
                    <div>报名单位：</div>
                    <div>{{margin.enrollCompanyName}}</div>
                  </div>
                  <Icon
                    type="ios-information-outline"
                    style="font-size:14px;line-height:16px;"
                  ></Icon>
                </Tooltip>
                <span
                  class="split"
                  style="color:#2d8cf0;"
                  v-if="margin.splitMarginId"
                  @click="backSplit(margin, marginIndex)"
                >撤回</span>
              </div>
            </draggable>
            <div
              v-if="group.marginCompanyList.length===0"
              style="width:100%;text-align:center;position:absolute;top:8px;"
            >拖拽到此</div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button @click="receiveConfirmVisible=false">取消</Button>
        <Button
          type="primary"
          @click="createMarginOrders"
        >确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="enrollConfirmVisible"
      title="供应商确认"
      width="600"
      :closable="false"
      :mask-closable="false"
    >
      <span style="color:#ed4014">当前选择的保证金收取账号单位名称与报名供应商不一致或不存在，请确认选择报名供应商名称</span>
      <Table
        :columns="enrollColumns"
        :data="enrollList"
        style="margin-top:5px;"
      ></Table>
      <Page
        :total="total"
        :current="currentPage"
        show-elevator
        show-total
        :page-size="8"
        style="margin-top:5px;"
        @on-change="pageChange"
      ></Page>
      <div slot="footer">
        <Button @click="cancelEnrollConfirm">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="confirmAmountVisible"
      title="保证金金额"
      :closable="false"
      :mask-closable="false"
    >
      <span style="color:#ed4014">当前选择的保证金金额与包组应收保证金金额不符，请确认保证金金额</span>
      <Input v-model="confirmAmount"></Input>
      <div slot="footer">
        <Button @click="cancelEnrollConfirm">取消</Button>
        <Button
          type="primary"
          @click="confirmReceiveAmount"
        >确认</Button>
      </div>
    </Modal>
    <Modal
      v-model="groupChooseVisible"
      title="包组选择"
      :transfer="true"
      :mask-closable="false"
      :closable="false"
    >
      <div>
        <div
          v-for="group in groupList"
          style="min-height:35px;line-height:35px;"
        >
          <Checkbox v-model="group.isChoose">包组{{group.groupNo}}：{{group.groupName}}
            <span style="color:#19be6b">（应收保证金：{{group.marginAmount}}）</span>
          </Checkbox>
          <span v-if="group.isChoose">
            <span>金额：</span>
            <Input
              v-model="group.fee"
              style="width:100px;"
            ></Input>
            <span>元</span>
          </span>
        </div>
      </div>
      <div slot="footer">
        <Button @click="cancelGroup">取消</Button>
        <Button
          type="primary"
          @click="receiveDeposit"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import requestUrls from '@/lib/requestUrls'
import ajax from '@/lib/ajax'

export default {
  components: {
    draggable
  },
  props: {
    marginDetail: {
      type: Array,
      default: () => {
        return []
      }
    },
    projectData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      columns: [
        {
          title: '单位名称',
          key: 'ghfAccountName',
          width: 300
        },
        {
          title: '摘要',
          width: 200,
          key: 'digest'
        },
        {
          title: '金额',
          width: 100,
          key: 'amount'
        },
        {
          title: '收取时间',
          width: 100,
          key: 'dealTime',
          render: (h, params) => {
            let time = ''
            if (params.row.dealTime) {
              time = params.row.dealTime.split('T')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '领取',
          // width: 60,
          render: (h, params) => {
            let state = '未领'
            let stateColor = '#ed4014'
            if (params.row.state === 1 || params.row.state === 2) {
              state = '已领'
              stateColor = '#19be6b'
            }
            return h('div',{
              style: {
                color: stateColor
              }
            }, state)
          }
        }
      ],
      marginDetailList: [],
      cutList: [],
      cutLength: 3, // 截取长度
      isShowStatus: false,
      receiveConfirmVisible: false,
      groupList: [],
      drapMarginList: [],
      orderList: [],
      orderColumns: [
        {
          title: '单位名称',
          key: 'ghfCompanyName'
        },
        {
          title: '金额',
          width: 100,
          key: 'orderAmountTotal'
        },
        {
          title: '包组',
          width: 80,
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.clGroupDb.groupNo)
          }
        },
        {
          title: '领取时间',
          width: 150,
          render: (h, params) => {
            let time = ''
            if (params.row.payTime) {
              time = params.row.payTime.split('T')[0]
            }
            return h('div', time)
          }
        }
      ],
      enrollConfirmVisible: false,
      enrollList: [],
      enrollColumns: [
        {
          title: '投标单位',
          key: 'companyName'
        },
        {
          title: '项目编号',
          key: 'projectFull',
          width: 180
        },
        {
          title: '操作',
          width: 80,
          render: (h, params) => {
            return h('Button', {
              props: {
                size: 'small',
                type: 'primary'
              },
              on: {
                click: () => {
                  this.enrollConfirmVisible = false
                  if (this.splitStatus) {
                    this.splitCompanyName = params.row.companyName
                    this.clearGroupChoose()
                    this.groupChooseVisible = true
                    return
                  }
                  this.operateDragItem.enrollCompanyName = params.row.companyName
                }
              }
            }, '选择')
          }
        }
      ],
      total: 0,
      currentPage: 1,
      operateGroupIndex: '',
      operateDragItem: '',
      operateDragIndex: '',
      confirmAmountVisible: false,
      confirmAmount: '',
      groupChooseVisible: false,
      splitMarginIndex: '',
      splitCompanyName: '',
      splitStatus: false,
    }
  },
  methods: {
    cancelGroup() {
      this.groupChooseVisible = false
      this.splitStatus = false
    },
    showMore() {
      this.isShowStatus = true
      this.marginDetailList = [...this.marginDetailList, ...this.cutList]
    },
    retract() {
      this.isShowStatus = false
      this.marginDetailList = this.marginDetailList.slice(0, this.cutLength)
    },
    async receiveConfirm() {
      this.$Spin.show()
      if (this.groupList.length === 0) {
        await this.getGroupList()
      }
      // 获取单位名称不相符的公司
      let differentCompany = await this.getDifferentCompany(this.projectData.id)
      this.identifyMargin(differentCompany)
      // 获取订单，留下未匹配数据
      await this.getOrderList(this.projectData.id)

      // 去除已认领过的
      this.removeReceived()

      this.$Spin.hide()
      this.receiveConfirmVisible = true
    },
    async getOrderList(projectId) {
      let rep = await ajax.get(requestUrls.order.getPaged, {
        params: {
          filter: `projectId==${projectId} and orderType == "保证金"`,
          sorting: '',
          maxResultCount: 500,
          skipCount: 0
        }
      })
      if (rep.data.success) {
        this.orderList = rep.data.result.items
      }
    },
    // 查询差异(保证金账号单位名称与报名单位名称不一致)
    async getDifferentCompany(projectId) {
      let rep = await ajax.get(requestUrls.ClMargin.GetDifferent, {
        params: {
          projectId: projectId
        }
      })
      if (rep.data.success) {
        return rep.data.result
      }
      return []
    },
    // 对差异单位名称进行标识
    identifyMargin(differentCompany = []) {
      differentCompany.forEach(item => {
        for (let i = 0; i < this.drapMarginList.length; i++) {
          if (this.drapMarginList[i].bankSeqNo === item.bankSeqNo) {
            this.drapMarginList[i].isDifferent = true
          }
        }
      })
    },
    // 去除已认领数据并添加进包组列表
    async removeReceived() {

      // 遍历拆分订单
      let delMarginIndex = []
      let delOrderIndex = []
      for (let i = 0; i < this.drapMarginList.length; i++) {
        let drapMargin = this.drapMarginList[i]
        drapMargin.isReceived = false
        for (let j = 0; j < this.orderList.length; j++) {
          let order = this.orderList[j]
          let marginAmount = parseFloat(drapMargin.amount)
          if (order.marginSeqNo === drapMargin.bankSeqNo) {
            if (delMarginIndex.indexOf(i) === -1) {
              delMarginIndex.unshift(i)
            }
            let copyDrapMargin = JSON.parse(JSON.stringify(drapMargin))
            this.$set(copyDrapMargin, 'confirmAmount', order.orderAmountTotal)
            this.$set(copyDrapMargin, 'enrollCompanyName', order.ghfCompanyName)
            copyDrapMargin.isReceived = true
            for (let k = 0; k < this.groupList.length; k++) {
              let group = this.groupList[k]
              if (group.id === order.abpOrdersExp.groupId) {
                group.marginCompanyList.push(copyDrapMargin)
                break
              }
            }
            delOrderIndex.unshift(j)
          }
        }

      }
      delMarginIndex.forEach(marginIndex => {
        this.drapMarginList.splice(marginIndex, 1)
      })
      delOrderIndex.forEach(orderIndex => {
        this.orderList.splice(orderIndex, 1)
      })

      // 遍历订单
      // for (let i = 0; i < this.drapMarginList.length; i++) {
      //   let drapMargin = this.drapMarginList[i]
      //   drapMargin.isReceived = false
      //   for (let j = 0; j < this.orderList.length; j++) {
      //     let order = this.orderList[j]
      //     let marginAmount = parseFloat(drapMargin.amount)
      //     if ((order.ghfCompanyName === drapMargin.ghfAccountName || order.abpOrdersExp.bankName === drapMargin.ghfAccountName) && order.orderAmountTotal === marginAmount) {
      //       // 将对应margin放进包组列表
      //       this.$set(drapMargin, 'confirmAmount', order.orderAmountTotal)
      //       this.$set(drapMargin, 'enrollCompanyName', order.ghfCompanyName)
      //       drapMargin.isReceived = true
      //       for (let k = 0; k < this.groupList.length; k++) {
      //         let group = this.groupList[k]
      //         if (group.id === order.abpOrdersExp.groupId) {
      //           group.marginCompanyList.push(drapMargin)
      //           break
      //         }
      //       }

      //       // 删除对应margin和对应order
      //       this.orderList.splice(j, 1)
      //       this.drapMarginList.splice(i, 1)
      //       i--
      //       break
      //     }
      //   }
      // }
    },
    // 获取包组
    async getGroupList() {
      let rep = await ajax.get(requestUrls.ClGroupDb.getPaged, {
        params: {
          filter: `projectId==${this.projectData.id}`,
          maxResultCount: 500,
          skipCount: 0
        }
      })
      if (rep.data.success) {
        this.groupList = this.handleGroupList(rep.data.result.items)
      }
    },
    // 包组排序
    handleGroupList(groupList) {
      let orderList = []
      groupList.forEach(group => {
        this.$set(group, 'marginCompanyList', [])
        this.$set(group, 'isChoose', false)
        this.$set(group, 'fee', '')
        let index = parseInt(group.groupNo) - 1
        orderList[index] = group
      })
      let orderResult = []
      // 去除空数据并记录第一个空的位置
      for (let i = 0; i < orderList.length; i++) {
        let item = orderList[i]
        if (item) {
          orderResult.push(item)
        }
      }
      return orderResult
    },
    autoMatch() {
      for (let i = 0; i < this.groupList.length; i++) {
        let group = this.groupList[i]

        for (let j = 0; j < this.drapMarginList.length; j++) {
          let drapMargin = this.drapMarginList[j]

          if (drapMargin.isDifferent) {
            continue
          }

          let drapMarginAmount = parseFloat(this.drapMarginList[j].amount)
          if (drapMarginAmount === group.marginAmount) {
            // 如果已经存在，则排除
            let isPush = false
            for (let k = 0; k < group.marginCompanyList.length; k++) {
              let company = group.marginCompanyList[k]
              if (company.ghfAccountName === drapMargin.ghfAccountName && company.amount === drapMargin.amount) {
                isPush = true
                break
              }
            }

            if (!isPush) {
              this.$set(drapMargin, 'confirmAmount', drapMarginAmount)
              this.$set(drapMargin, 'enrollCompanyName', drapMargin.ghfAccountName)
              group.marginCompanyList.push(drapMargin)
              this.drapMarginList.splice(j, 1)
              j--
            }

          }
        }

        if (this.drapMarginList.length === 0) {
          break
        }

      }
    },
    async addMarginItem(dragElement) {
      let newIndex = dragElement.newIndex
      let targetNodes = dragElement.target.childNodes
      let className = targetNodes[newIndex].className
      let groupIndex = ''
      if (className.indexOf('group') !== -1) {
        let classNames = className.split(' ')
        for (let i = classNames.length - 1; i >= 0; i--) {
          if (classNames[i].indexOf('group') !== -1) {
            groupIndex = parseInt(classNames[i].split('group')[1])
          }
        }
      }
      let newDragItem = this.groupList[groupIndex].marginCompanyList[newIndex]

      this.operateGroupIndex = groupIndex
      this.operateDragItem = newDragItem
      this.operateDragIndex = newIndex

      let amount = parseFloat(newDragItem.amount)
      this.$set(newDragItem, 'confirmAmount', amount)
      this.$set(newDragItem, 'enrollCompanyName', newDragItem.ghfAccountName)

      // 是否已经领取
      this.$Spin.show()
      let canDrap = await this.ifMarginExists(this.projectData.id, this.groupList[groupIndex].id, newDragItem.ghfAccountName, amount)
      this.$Spin.hide()
      if (!canDrap) {
        this.$Modal.confirm({
          title: '认领已存在',
          content: '当前选择的包组已存在此公司此金额的保证金认领信息，是否继续？',
          onOk: () => {
            // 包组金额大于汇款金额
            if (this.groupList[groupIndex].marginAmount < amount) {
              this.amountDifferentModal()
              return
            }
            this.ifCompanyDifferent()
          },
          onCancel: () => {
            this.drapMarginList.push(this.operateDragItem)
            this.groupList[this.operateGroupIndex].marginCompanyList.splice(this.operateDragIndex, 1)
          }
        })
      }

      // 包组金额大于汇款金额
      if (this.groupList[groupIndex].marginAmount < amount) {
        this.amountDifferentModal()
        return
      }
      this.ifCompanyDifferent()
    },
    // 金额不符判定
    amountDifferentModal() {
      this.$Modal.confirm({
        title: '金额不符',
        content: '当前选择包组金额小于汇款金额，请检查是否正确或选择拆分金额',
        onOk: () => {
          this.drapMarginList.push(this.operateDragItem)
          this.groupList[this.operateGroupIndex].marginCompanyList.splice(this.operateDragIndex, 1)
        },
        onCancel: () => {
          this.drapMarginList.push(this.operateDragItem)
          this.groupList[this.operateGroupIndex].marginCompanyList.splice(this.operateDragIndex, 1)
        }
      })
    },
    // 公司名与报名信息不同区别
    async ifCompanyDifferent() {
      // 公司名字不同情况
      if (this.operateDragItem.isDifferent) {
        this.$Spin.show()
        let enroll = await this.getEnroll(1, { projectId: this.projectData.id })
        this.$Spin.hide()
        this.total = enroll.totalCount
        this.enrollList = enroll.items
        this.enrollConfirmVisible = true
      }
    },
    addMarginItemBack(dragElement) {
      // 拖拽回原来的地方清空实际公司名和实际费用
      let newIndex = dragElement.newIndex
      let backDrapItem = this.drapMarginList[newIndex]
      backDrapItem.confirmAmount = ''
      backDrapItem.enrollCompanyName = ''
    },
    // 查询是否已经领取
    async ifMarginExists(projectId = '', groupId = '', bankName = '', amount = '') {
      let rep = await ajax.post(requestUrls.order.MarginExistsList, [
        {
          projectId: projectId,
          groupId: groupId,
          bankName: bankName,
          amount: amount
        }
      ])
      if (rep.data.success) {
        return rep.data.result
      }
      return false
    },
    async confirmReceiveAmount() {
      if (this.confirmAmount === '') {
        this.$Message.info('请输入认领金额')
        return
      }
      let amount = parseFloat(this.operateDragItem.amount)
      if (parseInt(this.confirmAmount) > amount) {
        this.$Message.info('认领金额不能大于汇款金额')
        return
      }
      this.operateDragItem.confirmAmount = this.confirmAmount
      this.confirmAmountVisible = false
      // 公司名字不同判断
      if (this.operateDragItem.isDifferent) {
        this.$Spin.show()
        let enroll = await this.getEnroll(1, { projectId: this.projectData.id })
        this.$Spin.hide()
        this.total = enroll.totalCount
        this.enrollList = enroll.items
        this.enrollConfirmVisible = true
      }
    },
    async getEnroll(page, { companyName = '', numFull = '', numAbbr = '', absoluteCompany = '', projectId = '' }) {
      this.currentPage = page
      let defaultSear = ' and e.status == "3"' // 只获取报名成功的
      let companySear = companyName ? ` and e.companyName.contains("${companyName}")` : ''
      let numFullSear = numFull ? ` and e.projectFull.contains("${numFull}")` : ''
      let numAbbrSear = numAbbr ? ` and e.projectShort.contains("${numAbbr}")` : ''
      let abCompanySear = absoluteCompany ? ` and e.companyName == "${absoluteCompany}"` : ''
      let projectIdSear = projectId ? ` and e.projectId == "${projectId}"` : ''

      let filter = defaultSear + companySear + numFullSear + numAbbrSear + abCompanySear + projectIdSear
      filter = filter.slice(5)

      let rep = await ajax.get(requestUrls.enroll.getPaged, {
        params: {
          filter: filter,
          sort: 'creationTime desc',
          maxResultCount: 8,
          skipCount: (page - 1) * 8
        }
      })
      if (rep.data.success) {
        // this.total = rep.data.result.totalCount
        // this.enrollList = rep.data.result.items
        return rep.data.result
      }
      let faildItem = {
        totalCount: 0,
        items: []
      }
      return faildItem
    },
    async pageChange(page) {
      let enroll = await this.getEnroll(page, { projectId: this.projectData.id })
      this.total = enroll.totalCount
      this.enrollList = enroll.items
    },
    cancelEnrollConfirm() {
      // 取消确认，将原来拖拽返回未领取位置
      if (!this.splitStatus) {
        this.drapMarginList.push(this.operateDragItem)
        this.groupList[this.operateGroupIndex].marginCompanyList.splice(this.operateDragIndex, 1)
      }
      this.splitStatus = false
      this.enrollConfirmVisible = false
      this.confirmAmountVisible = false
    },
    async createMarginOrders() {
      let confirmOrderList = []
      this.groupList.forEach(group => {
        for (let i = 0; i < group.marginCompanyList.length; i++) {
          let margin = group.marginCompanyList[i]
          // 已经确认的排除
          if (!margin.isReceived) {
            let payTime = margin.dealTime.replace('T', ' ')
            let orderItem = {
              "orderStatus": "2",
              "orderAmountTotal": margin.confirmAmount,
              "marginSeqNo": margin.bankSeqNo,
              "redOrderNo": "",
              "orderType": "保证金",
              "ghfInvoiceTaxNo": '',
              "ghfCompanyName": margin.enrollCompanyName,
              "ghfCompanyAddress": '',
              "ghfTelphone": '',
              "ghfBankName": '',
              "ghfBankAccount": '',
              "xhfInvoiceTaxNo": "",
              "xhfCompanyName": "",
              "xhfCompanyAddress": "",
              "xhfTelphone": "",
              "xhfBankName": "",
              "xhfBankAccount": "",
              "projectFull": this.projectData.projectFull,
              "district": this.projectData.district,
              "payChannel": margin.bank,
              "payTime": payTime,
              "confirm": this.$store.state.session.user.name,
              "clMarginId": margin.id,
              "abpOrdersExp": {
                "bankName": margin.ghfAccountName,
                "bankAccount": margin.ghfAccount,
                "projectId": this.projectData.id,
                "groupId": group.id,
                "groupName": ""
              },
              "projectId": this.projectData.id
            }
            confirmOrderList.push(orderItem)
          }
        }
      })
      this.$Spin.show()
      try {
        let rep = await ajax.post(requestUrls.order.MarginOrdersList, confirmOrderList)
        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('确认成功')
          // 刷新数据
          // this.$Spin.show()
          // this.drapMarginList = JSON.parse(JSON.stringify(this.marginDetail))
          // await this.getGroupList()
          // // 获取单位名称不相符的公司
          // let differentCompany = await this.getDifferentCompany(this.projectData.id)
          // this.identifyMargin(differentCompany)
          // // 获取订单，留下未匹配数据
          // await this.getOrderList(this.projectData.id)
          // // 去除已认领过的
          // this.removeReceived()
          // this.$Spin.hide()

          this.receiveConfirmVisible = false
          this.$emit('refreshData')

        } else {
          this.$Message.error('操作失败')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('操作失败')
      }
    },
    async splitAmount(marginItem, index) {
      this.drapMarginItem = marginItem
      this.splitMarginIndex = index

      this.splitStatus = false
      this.splitCompanyName = ''
      if (marginItem.isDifferent) {
        this.splitStatus = true
        this.$Spin.show()
        let enroll = await this.getEnroll(1, { projectId: this.projectData.id })
        this.$Spin.hide()
        this.total = enroll.totalCount
        this.enrollList = enroll.items
        this.enrollConfirmVisible = true
      } else {
        this.clearGroupChoose()
        this.groupChooseVisible = true
      }
    },
    // 清楚包组选择及金额
    clearGroupChoose() {
      this.groupList.forEach(group => {
        group.isChoose = false
        group.fee = ''
      })
    },
    receiveDeposit() {
      // 拆分推进个包组队列
      this.splitStatus = false
      let isFilled = true
      let amount = 0
      this.groupList.forEach(group => {
        if (group.isChoose && (group.fee === '' || isNaN(parseFloat(group.fee)))) {
          isFilled = false
        }
        if (group.isChoose && !isNaN(parseFloat(group.fee))) {
          amount += parseFloat(group.fee)
        }
      })
      // 判断是否填入
      if (!isFilled) {
        this.$Message.info('勾选的包组请输入金额')
        return
      }
      // 判断总额是否超过汇款金额
      if (this.drapMarginItem.amount !== amount) {
        this.$Message.info("拆分后总金额不等于汇款金额")
        return
      }

      this.groupList.forEach(group => {
        if (group.isChoose) {
          let copyMargin = JSON.parse(JSON.stringify(this.drapMarginItem))
          copyMargin.splitMarginId = this.drapMarginItem.id
          // this.$set(copyMargin, 'splitMarginId', this.drapMarginItem.id)
          copyMargin.confirmAmount = group.fee
          copyMargin.enrollCompanyName = this.drapMarginItem.ghfAccountName
          if (this.splitCompanyName) {
            copyMargin.enrollCompanyName = this.splitCompanyName
          }
          group.marginCompanyList.push(copyMargin)
        }
      })
      this.drapMarginList.splice(this.splitMarginIndex, 1)
      this.groupChooseVisible = false
    },
    backSplit(marginItem, index) {
      let backSplitMargin = marginItem
      this.groupList.forEach(group => {
        for (let i = 0; i < group.marginCompanyList.length; i++) {
          let margin = group.marginCompanyList[i]
          if (margin.id === backSplitMargin.splitMarginId) {
            group.marginCompanyList.splice(i, 1)
            i--
          }
        }
      })
      backSplitMargin.confirmAmount = ''
      backSplitMargin.enrollCompanyName = ''
      backSplitMargin.splitMarginId = ''
      this.drapMarginList.push(backSplitMargin)
    },
  },
  watch: {
    marginDetail: {
      handler(val) {
        this.drapMarginList = JSON.parse(JSON.stringify(val))
        this.marginDetailList = val
        if (val.length >= this.cutLength) {
          this.marginDetailList = val.slice(0, this.cutLength)
          this.cutList = val.slice(this.cutLength)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less">
.margin-company {
  position: relative;
  padding: 5px 10px;
  margin: 10px auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  width: 620px;
  cursor: pointer;
  .amount {
    position: absolute;
    right: 100px;
  }
  .confirm {
    position: absolute;
    right: 55px;
  }
  .get-amount {
    position: absolute;
    left: 250px;
  }
  .split {
    position: absolute;
    right: 5px;
  }
}
.left-margin {
  width: 420px;
}
.left-wrapper,
.right-wrapper {
  margin: 0 5px;
  display: inline-block;
  width: 40%;
  max-height: 500px;
  overflow: auto;
  vertical-align: top;
}
.right-wrapper {
  width: 58%;
}
</style>
